import { getAvatarImage } from '@features/avatar/components/Avatar/helpers';

import { IAvatar } from '@interfaces/avatar';
import SelectAvatarSkinItem from '@core/avatar/components/SelectAvatarSkinItem';

const Avatar = ({
  avatar,
  onClick,
}: {
  avatar: IAvatar;
  onClick: () => void;
}) => {
  return (
    <SelectAvatarSkinItem
      src={getAvatarImage(avatar)}
      alt={avatar.name}
      onClick={onClick}
    />
  );
};

export default Avatar;
